import { PermissionEnum } from '../../shared/models/permission.enum';
import { UcVersion } from '../../shared/models/uc-version.enum';

export const builderElementCurrentVersion = '0.0.0.1';

export const availableCms = [
  {
    cms: 'IGT',
    label: 'IGT(v1)',
    value: '0',
    version: UcVersion.Version_1,
  },
  {
    cms: 'Envoy',
    label: 'Envoy',
    value: '1',
    version: UcVersion.Version_2,
  },
  {
    cms: 'Local',
    label: 'Local',
    value: '3',
    version: UcVersion.Version_1,
  },
  {
    cms: 'IGT',
    label: 'IGT(v2)',
    value: '4',
    version: UcVersion.Version_2,
  },
  {
    cms: 'OLKG',
    label: 'OLKG',
    value: '5',
    version: UcVersion.Version_2,
  },
  {
    cms: 'Synkros',
    label: 'Synkros',
    value: '6',
    version: UcVersion.Version_2,
  },
];

export const availableDatapointPlacement = [
  { title: 'Welcome Message', value: 'welcomeMessage' },
  { title: 'Data Points', value: 'dataPoints' },
  { title: 'Tier Level Card', value: 'tierLevelCard' },
  { title: 'Additional Info', value: 'additionalInfo' },
  { title: 'Tier Levels', value: 'tierLevels' },
];

export const navigationElements: any = [
  {
    title: 'Kiosk Builder',
    icon: 'dvr',
    permissions: [
      PermissionEnum.full,
      [PermissionEnum.access, PermissionEnum.kioskBuilder],
    ],
    sections: [
      {
        title: 'Content',
        icon: 'dvr',
        routes: [
          {
            name: 'Layout',
            url: '/builder',
            permissions: null,
          },
          {
            name: 'Tier levels',
            url: '/tier-levels',
            permissions: null,
          },
        ],
      },
      {
        title: 'Settings',
        icon: 'settings',
        routes: [
          {
            name: 'Global variables',
            url: '/global-variables',
            permissions: null,
          },
          {
            name: 'Advanced settings',
            url: '/advanced-settings',
            permissions: [PermissionEnum.full],
          },
          {
            name: 'Logs',
            url: '/logs',
            permissions: [PermissionEnum.full],
          },
          {
            name: 'Components',
            url: '/components',
            permissions: null,
          },
          {
            name: 'Data Points Manager',
            url: '/data-point-manager',
            permissions: [PermissionEnum.full],
          },
          {
            name: 'Swap Offers',
            url: '/swap-offers',
            permissions: [
              PermissionEnum.full,
              [PermissionEnum.access, PermissionEnum.offers],
            ]
          },
        ],
      },
      {
        title: 'Admin Helper',
        icon: 'helper',
        permissions: [PermissionEnum.full],
        routes: [
          {
            name: 'Get Kiosk URL',
            url: '/get-kiosk-url',
            permissions: [PermissionEnum.full],
          },
        ],
      },
    ],
  },
  {
    title: 'Media Manager',
    icon: 'perm_media',
    permissions: [
      PermissionEnum.full,
      [PermissionEnum.access, PermissionEnum.mediaManager],
    ],
    sections: [
      {
        title: '',
        icon: '',
        routes: [
          {
            name: 'Kiosk Carousel',
            url: '/media-manager/kiosk-carousel',
            permissions: null,
          },
          {
            name: 'CHS Image Loop',
            url: '/media-manager/chs-image-carousel',
            permissions: null,
          },
          {
            name: 'Sidecar',
            url: '/media-manager/sidecar',
            permissions: null,
          },
        ],
      },
    ],
  },
  {
    title: 'Offers',
    icon: 'receipt',
    permissions: [
      PermissionEnum.full,
      [PermissionEnum.access, PermissionEnum.offers],
    ],
    url: '/offers-configuration-list'
  },
  {
    title: 'Cms Drawing',
    icon: 'receipt',
    permissions: [
      PermissionEnum.full,
      [PermissionEnum.access, PermissionEnum.drawings],
    ],
    url: '/cms-drawing-configuration-list',
  },
];

export const fontFamilyOption = [
  'Arial',
  'Source Sans Pro',
  'Open Sans',
  'Montserrat',
  'Helvetica',
  'Proxima Nova',
  'Bebas Neue',
  'Merriweather Sans',
  'Garamond',
  'Lato',
  'Avenir',
  'Graphik',
  'Gotham',
  'Roboto',
  'Campton',
  'DIN Condensed',
  'Playfair Display',
  'Big Caslon',
  'sans-serif',
  'serif',
  'Marcellus',
  'Poppins',
];

export const iconSize = ['34*34', '36*36','38*38','40*40', '48*48', '72*72', '96*96'];

export const fontWeight = [
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
];

export const buttonStyle = ['Outlined', 'Text', 'Plain'];

export const modalPosition = ['At the bottom of the screen'];

export const matIcons = [
  '123',
  '360',
  '1x_mobiledata',
  '1k_plus',
  '1k',
  '19mp',
  '18mp',
  '18_up_rating',
  '17mp',
  '16mp',
  '15mp',
  '14mp',
  '13mp',
  '12mp',
  '11mp',
  '10mp',
  '10k',
  '2k_plus',
  '24mp',
  '23mp',
  '22mp',
  '21mp',
  '20mp',
  '2mp',
  '2k',
  '3p',
  '3mp',
  '3k_plus',
  '3k',
  '3g_mobiledata',
  '3d_rotation',
  '30fps_select',
  '30fps',
  '4mp',
  '4k_plus',
  '4k',
  '4g_plus_mobiledata',
  '4g_mobiledata',
  '5mp',
  '5k_plus',
  '5k',
  '5g',
  '6mp',
  '6k_plus',
  '6k',
  '6_ft_apart',
  '60fps_select',
  '60fps',
  '7k_plus',
  '7mp',
  '7k',
  '8k_plus',
  '8mp',
  '8k',
  '9k_plus',
  '9mp',
  '9k',
  'av_timer',
  'autorenew',
  'autofps_select',
  'auto_stories',
  'auto_mode',
  'auto_graph',
  'auto_fix_off',
  'auto_fix_normal',
  'auto_fix_high',
  'auto_delete',
  'auto_awesome_motion',
  'auto_awesome_mosaic',
  'auto_awesome',
  'audiotrack',
  'audio_file',
  'attribution',
  'attractions',
  'attachment',
  'attach_money',
  'attach_file',
  'attach_email',
  'atm',
  'assured_workload',
  'assistant_photo',
  'assistant_navigation',
  'assistant_direction',
  'assistant',
  'assignment_turned_in',
  'assignment_returned',
  'assignment_return',
  'assignment_late',
  'assignment_ind',
  'assignment',
  'assessment',
  'aspect_ratio',
  'article',
  'art_track',
  'arrow_upward',
  'arrow_right_alt',
  'arrow_right',
  'arrow_left',
  'arrow_forward_ios',
  'arrow_forward',
  'arrow_drop_up',
  'arrow_drop_down_circle',
  'arrow_drop_down',
  'arrow_downward',
  'arrow_circle_up',
  'arrow_circle_right',
  'arrow_circle_left',
  'arrow_circle_down',
  'arrow_back_ios_new',
  'arrow_back_ios',
  'arrow_back',
  'area_chart',
  'archive',
  'architecture',
  'apps_outage',
  'apps',
  'approval',
  'apple',
  'app_shortcut',
  'app_settings_alt',
  'app_registration',
  'app_blocking',
  'api',
  'apartment',
  'aod',
  'announcement',
  'animation',
  'android',
  'anchor',
  'analytics',
  'amp_stories',
  'alternate_email',
  'alt_route',
  'all_out',
  'all_inclusive',
  'all_inbox',
  'align_vertical_top',
  'align_vertical_center',
  'align_vertical_bottom',
  'align_horizontal_right',
  'align_horizontal_left',
  'align_horizontal_center',
  'album',
  'alarm_on',
  'alarm_off',
  'alarm_add',
  'alarm',
  'airport_shuttle',
  'airplay',
  'airplanemode_on',
  'airplanemode_off',
  'airplanemode_inactive',
  'airplanemode_active',
  'airplane_ticket',
  'airlines',
  'airline_stops',
  'airline_seat_recline_normal',
  'airline_seat_recline_extra',
  'airline_seat_legroom_reduced',
  'airline_seat_legroom_normal',
  'airline_seat_legroom_extra',
  'airline_seat_individual_suite',
  'airline_seat_flat_angled',
  'airline_seat_flat',
  'air',
  'agriculture',
  'ads_click',
  'adobe',
  'admin_panel_settings',
  'adjust',
  'adf_scanner',
  'addchart',
  'add_to_queue',
  'add_to_photos',
  'add_to_home_screen',
  'add_to_drive',
  'add_task',
  'add_shopping_cart',
  'add_road',
  'add_reaction',
  'add_photo_alternate',
  'add_moderator',
  'add_location_alt',
  'add_location',
  'add_link',
  'add_ic_call',
  'add_home_work',
  'add_home',
  'add_comment',
  'add_circle_outline',
  'add_circle',
  'add_chart',
  'add_card',
  'add_call',
  'add_business',
  'add_box',
  'add_alert',
  'add_alarm',
  'add_a_photo',
  'add',
  'adb',
  'ad_units',
  'account_tree',
  'account_circle',
  'account_box',
  'account_balance_wallet',
  'account_balance',
  'accessible_forward',
  'accessible',
  'accessibility_new',
  'accessibility',
  'access_time_filled',
  'access_time',
  'access_alarms',
  'access_alarm',
  'ac_unit',
  'abc',
  'business_center',
  'business',
  'bus_alert',
  'burst_mode',
  'bungalow',
  'build_circle',
  'build',
  'bug_report',
  'bubble_chart',
  'brush',
  'brunch_dining',
  'browser_updated',
  'browser_not_supported',
  'browse_gallery',
  'broken_image',
  'broadcast_on_personal',
  'broadcast_on_home',
  'brightness_medium',
  'brightness_low',
  'brightness_high',
  'brightness_auto',
  'brightness_7',
  'brightness_6',
  'brightness_5',
  'brightness_4',
  'brightness_3',
  'brightness_2',
  'brightness_1',
  'breakfast_dining',
  'branding_watermark',
  'boy',
  'border_vertical',
  'border_top',
  'border_style',
  'border_right',
  'border_outer',
  'border_left',
  'border_inner',
  'border_horizontal',
  'border_color',
  'border_clear',
  'border_bottom',
  'border_all',
  'bookmarks',
  'bookmark_remove',
  'bookmark_outline',
  'bookmark_border',
  'bookmark_added',
  'bookmark_add',
  'bookmark',
  'book_online',
  'book',
  'bolt',
  'blur_on',
  'blur_off',
  'blur_linear',
  'blur_circular',
  'bluetooth_searching',
  'bluetooth_drive',
  'bluetooth_disabled',
  'bluetooth_connected',
  'bluetooth_audio',
  'bluetooth',
  'bloodtype',
  'block_flipped',
  'block',
  'blinds_closed',
  'blinds',
  'blender',
  'biotech',
  'bike_scooter',
  'bento',
  'beenhere',
  'bedtime_off',
  'bedtime',
  'bedroom_parent',
  'bedroom_child',
  'bedroom_baby',
  'bed',
  'beach_access',
  'battery_unknown',
  'battery_std',
  'battery_saver',
  'battery_full',
  'battery_charging_full',
  'battery_alert',
  'battery_6_bar',
  'battery_5_bar',
  'battery_4_bar',
  'battery_3_bar',
  'battery_2_bar',
  'battery_1_bar',
  'battery_0_bar',
  'bathtub',
  'bathroom',
  'batch_prediction',
  'bar_chart',
  'ballot',
  'balcony',
  'balance',
  'bakery_dining',
  'badge',
  'backup_table',
  'backup',
  'backspace',
  'backpack',
  'back_hand',
  'baby_changing_station',
  'cyclone',
  'curtains_closed',
  'curtains',
  'currency_yuan',
  'currency_yen',
  'currency_rupee',
  'currency_ruble',
  'currency_pound',
  'currency_lira',
  'currency_franc',
  'currency_exchange',
  'currency_bitcoin',
  'css',
  'cruelty_free',
  'crop_square',
  'crop_rotate',
  'crop_portrait',
  'crop_original',
  'crop_landscape',
  'crop_free',
  'crop_din',
  'crop_7_5',
  'crop_5_4',
  'crop_3_2',
  'crop_16_9',
  'crop',
  'crisis_alert',
  'crib',
  'credit_score',
  'credit_card_off',
  'credit_card',
  'create_new_folder',
  'create',
  'countertops',
  'cottage',
  'corporate_fare',
  'coronavirus',
  'copyright',
  'copy_all',
  'cookie',
  'control_point_duplicate',
  'control_point',
  'control_camera',
  'contrast',
  'content_paste_search',
  'content_paste_off',
  'content_paste_go',
  'content_paste',
  'content_cut',
  'content_copy',
  'contacts',
  'contactless',
  'contact_support',
  'contact_phone',
  'contact_page',
  'contact_mail',
  'construction',
  'connecting_airports',
  'connected_tv',
  'connect_without_contact',
  'confirmation_number',
  'confirmation_num',
  'computer',
  'compress',
  'compost',
  'compass_calibration',
  'compare_arrows',
  'compare',
  'commute',
  'commit',
  'comments_disabled',
  'comment_bank',
  'comment',
  'colorize',
  'color_lens',
  'collections_bookmark',
  'collections',
  'coffee_maker',
  'coffee',
  'code_off',
  'code',
  'co_present',
  'co2',
  'cloudy_snowing',
  'cloud_upload',
  'cloud_sync',
  'cloud_queue',
  'cloud_off',
  'cloud_download',
  'cloud_done',
  'cloud_circle',
  'cloud',
  'closed_caption_off',
  'closed_caption_disabled',
  'closed_caption',
  'close_fullscreen',
  'close',
  'clear_all',
  'clear',
  'cleaning_services',
  'clean_hands',
  'class',
  'circle_notifications',
  'circle',
  'church',
  'chrome_reader_mode',
  'child_friendly',
  'child_care',
  'chevron_right',
  'chevron_left',
  'checkroom',
  'checklist_rtl',
  'checklist',
  'check_circle_outline',
  'check_circle',
  'check_box_outline_blank',
  'check_box',
  'check',
  'chat_bubble_outline',
  'chat_bubble',
  'chat',
  'charging_station',
  'change_history',
  'change_circle',
  'chalet',
  'chair_alt',
  'chair',
  'center_focus_weak',
  'center_focus_strong',
  'cell_wifi',
  'cell_tower',
  'celebration',
  'category',
  'catching_pokemon',
  'castle',
  'cast_for_education',
  'cast_connected',
  'cast',
  'casino',
  'cases',
  'carpenter',
  'card_travel',
  'card_membership',
  'card_giftcard',
  'car_repair',
  'car_rental',
  'car_crash',
  'candlestick_chart',
  'cancel_schedule_send',
  'cancel_presentation',
  'cancel',
  'campaign',
  'cameraswitch',
  'camera_roll',
  'camera_rear',
  'camera_outdoor',
  'camera_indoor',
  'camera_front',
  'camera_enhance',
  'camera_alt',
  'camera',
  'call_to_action',
  'call_split',
  'call_received',
  'call_missed_outgoing',
  'call_missed',
  'call_merge',
  'call_made',
  'call_end',
  'call',
  'calendar_view_week',
  'calendar_view_month',
  'calendar_view_day',
  'calendar_today',
  'calendar_month',
  'calculate',
  'cake',
  'cached',
  'cable',
  'cabin',
  'dynamic_form',
  'dynamic_feed',
  'dvr',
  'duo',
  'dry_cleaning',
  'dry',
  'drive_folder_upload',
  'drive_file_rename_outline',
  'drive_file_move_rtl',
  'drive_file_move_outline',
  'drive_file_move',
  'drive_eta',
  'draw',
  'drag_indicator',
  'drag_handle',
  'drafts',
  'downloading',
  'download_for_offline',
  'download_done',
  'download',
  'downhill_skiing',
  'double_arrow',
  'doorbell',
  'door_sliding',
  'door_front',
  'door_back',
  'donut_small',
  'donut_large',
  'done_outline',
  'done_all',
  'done',
  'domain_verification',
  'domain_disabled',
  'domain_add',
  'domain',
  'document_scanner',
  'dock',
  'do_not_touch',
  'do_not_step',
  'do_not_disturb_on_total_silence',
  'do_not_disturb_on',
  'do_not_disturb_off',
  'do_not_disturb_alt',
  'do_not_disturb',
  'do_disturb_on',
  'do_disturb_off',
  'do_disturb_alt',
  'do_disturb',
  'dns',
  'dnd_forwardslash',
  'display_settings',
  'discount',
  'discord',
  'disc_full',
  'disabled_visible',
  'disabled_by_default',
  'dirty_lens',
  'directions_walk',
  'directions_transit_filled',
  'directions_transit',
  'directions_train',
  'directions_subway_filled',
  'directions_subway',
  'directions_run',
  'directions_railway_filled',
  'directions_railway',
  'directions_off',
  'directions_ferry',
  'directions_car_filled',
  'directions_car',
  'directions_bus_filled',
  'directions_bus',
  'directions_boat_filled',
  'directions_boat',
  'directions_bike',
  'directions',
  'dinner_dining',
  'dining',
  'difference',
  'diamond',
  'dialpad',
  'dialer_sip',
  'devices_other',
  'devices_fold',
  'devices',
  'device_unknown',
  'device_thermostat',
  'device_hub',
  'developer_mode',
  'developer_board_off',
  'developer_board',
  'details',
  'desktop_windows',
  'desktop_mac',
  'desktop_access_disabled',
  'desk',
  'design_services',
  'deselect',
  'description',
  'departure_board',
  'density_small',
  'density_medium',
  'density_large',
  'delivery_dining',
  'delete_sweep',
  'delete_outline',
  'delete_forever',
  'delete',
  'dehaze',
  'deck',
  'deblur',
  'date_range',
  'dataset_linked',
  'dataset',
  'data_usage',
  'data_thresholding',
  'data_saver_on',
  'data_saver_off',
  'data_object',
  'data_exploration',
  'data_array',
  'dashboard_customize',
  'dashboard',
  'dark_mode',
  'dangerous',
  'extension_off',
  'extension',
  'exposure_zero',
  'exposure_plus_2',
  'exposure_plus_1',
  'exposure_neg_2',
  'exposure_neg_1',
  'exposure_minus_2',
  'exposure_minus_1',
  'exposure',
  'explore_off',
  'explore',
  'explicit',
  'expand_more',
  'expand_less',
  'expand_circle_down',
  'expand',
  'exit_to_app',
  'event_seat',
  'event_repeat',
  'event_note',
  'event_busy',
  'event_available',
  'event',
  'ev_station',
  'euro_symbol',
  'euro',
  'escalator_warning',
  'escalator',
  'error_outline',
  'error',
  'equalizer',
  'enhanced_encryption',
  'enhance_photo_translate',
  'engineering',
  'energy_savings_leaf',
  'emoji_transportation',
  'emoji_symbols',
  'emoji_people',
  'emoji_objects',
  'emoji_nature',
  'emoji_food_beverage',
  'emoji_flags',
  'emoji_events',
  'emoji_emotions',
  'emergency_share',
  'emergency_recording',
  'emergency',
  'email',
  'elevator',
  'electrical_services',
  'electric_scooter',
  'electric_rickshaw',
  'electric_moped',
  'electric_meter',
  'electric_car',
  'electric_bolt',
  'electric_bike',
  'elderly_woman',
  'elderly',
  'eject',
  'egg_alt',
  'egg',
  'edit_road',
  'edit_off',
  'edit_notifications',
  'edit_note',
  'edit_location_alt',
  'edit_location',
  'edit_calendar',
  'edit_attributes',
  'edit',
  'edgesensor_low',
  'edgesensor_high',
  'eco',
  'east',
  'earbuds_battery',
  'earbuds',
  'e_mobiledata',
  'functions',
  'fullscreen_exit',
  'fullscreen',
  'front_hand',
  'free_cancellation',
  'free_breakfast',
  'foundation',
  'forward_to_inbox',
  'forward_5',
  'forward_30',
  'forward_10',
  'forward',
  'forum',
  'fort',
  'format_underlined',
  'format_underline',
  'format_textdirection_r_to_l',
  'format_textdirection_l_to_r',
  'format_strikethrough',
  'format_size',
  'format_shapes',
  'format_quote',
  'format_paint',
  'format_overline',
  'format_list_numbered_rtl',
  'format_list_numbered',
  'format_list_bulleted',
  'format_line_spacing',
  'format_italic',
  'format_indent_increase',
  'format_indent_decrease',
  'format_color_text',
  'format_color_reset',
  'format_color_fill',
  'format_clear',
  'format_bold',
  'format_align_right',
  'format_align_left',
  'format_align_justify',
  'format_align_center',
  'fork_right',
  'fork_left',
  'forest',
  'food_bank',
  'font_download_off',
  'font_download',
  'follow_the_signs',
  'folder_zip',
  'folder_special',
  'folder_shared',
  'folder_open',
  'folder_off',
  'folder_delete',
  'folder_copy',
  'folder',
  'foggy',
  'fmd_good',
  'fmd_bad',
  'flutter_dash',
  'flourescent',
  'flood',
  'flip_to_front',
  'flip_to_back',
  'flip_camera_ios',
  'flip_camera_android',
  'flip',
  'flight_takeoff',
  'flight_land',
  'flight_class',
  'flight',
  'flatware',
  'flashlight_on',
  'flashlight_off',
  'flash_on',
  'flash_off',
  'flash_auto',
  'flare',
  'flaky',
  'flag_circle',
  'flag',
  'fitness_center',
  'fitbit',
  'fit_screen',
  'first_page',
  'fireplace',
  'fire_truck',
  'fire_hydrant_alt',
  'fire_hydrant',
  'fire_extinguisher',
  'fingerprint',
  'find_replace',
  'find_in_page',
  'filter_vintage',
  'filter_tilt_shift',
  'filter_none',
  'filter_list_off',
  'filter_list_alt',
  'filter_list',
  'filter_hdr',
  'filter_frames',
  'filter_drama',
  'filter_center_focus',
  'filter_b_and_w',
  'filter_alt_off',
  'filter_alt',
  'filter_9_plus',
  'filter_9',
  'filter_8',
  'filter_7',
  'filter_6',
  'filter_5',
  'filter_4',
  'filter_3',
  'filter_2',
  'filter_1',
  'filter',
  'file_upload',
  'file_present',
  'file_open',
  'file_download_off',
  'file_download_done',
  'file_download',
  'file_copy',
  'fiber_smart_record',
  'fiber_pin',
  'fiber_new',
  'fiber_manual_record',
  'fiber_dvr',
  'festival',
  'fence',
  'female',
  'feedback',
  'feed',
  'featured_video',
  'featured_play_list',
  'fax',
  'favorite_outline',
  'favorite_border',
  'favorite',
  'fastfood',
  'fast_rewind',
  'fast_forward',
  'family_restroom',
  'factory',
  'fact_check',
  'facebook',
  'face_retouching_off',
  'face_retouching_natural',
  'face',
  'groups',
  'group_work',
  'group_remove',
  'group_off',
  'group_add',
  'group',
  'grid_view',
  'grid_on',
  'grid_off',
  'grid_goldenratio',
  'grid_4x4',
  'grid_3x3',
  'grass',
  'graphic_eq',
  'grain',
  'grading',
  'gradient',
  'grade',
  'gps_off',
  'gps_not_fixed',
  'gps_fixed',
  'gpp_maybe',
  'gpp_good',
  'gpp_bad',
  'golf_course',
  'goat',
  'gite',
  'girl',
  'gif_box',
  'gif',
  'get_app',
  'gesture',
  'generating_tokens',
  'gavel',
  'gas_meter',
  'garage',
  'games',
  'gamepad',
  'g_translate',
  'g_mobiledata',
  'hvac',
  'hub',
  'https',
  'http',
  'html',
  'how_to_vote',
  'how_to_reg',
  'houseboat',
  'house_siding',
  'house',
  'hourglass_top',
  'hourglass_full',
  'hourglass_empty',
  'hourglass_disabled',
  'hourglass_bottom',
  'hotel_class',
  'hotel',
  'hot_tub',
  'horizontal_split',
  'horizontal_rule',
  'horizontal_distribute',
  'home_work',
  'home_repair_service',
  'home_mini',
  'home_max',
  'home_filled',
  'home',
  'holiday_village',
  'hls_off',
  'hls',
  'hive',
  'history_toggle_off',
  'history_edu',
  'history',
  'hiking',
  'highlight_remove',
  'highlight_off',
  'highlight_alt',
  'highlight',
  'high_quality',
  'hide_source',
  'hide_image',
  'hexagon',
  'hevc',
  'help_outline',
  'help_center',
  'help',
  'height',
  'heat_pump',
  'heart_broken',
  'hearing_disabled',
  'hearing',
  'health_and_safety',
  'healing',
  'headset_off',
  'headset_mic',
  'headset',
  'headphones_battery',
  'headphones',
  'hdr_weak',
  'hdr_strong',
  'hdr_plus',
  'hdr_on_select',
  'hdr_on',
  'hdr_off_select',
  'hdr_off',
  'hdr_enhanced_select',
  'hdr_auto_select',
  'hdr_auto',
  'hd',
  'hardware',
  'handyman',
  'handshake',
  'hail',
  'h_plus_mobiledata',
  'h_mobiledata',
  'iso',
  'iron',
  'ios_share',
  'invert_colors_on',
  'invert_colors_off',
  'invert_colors',
  'inventory_2',
  'inventory',
  'interpreter_mode',
  'interests',
  'integration_instructions',
  'install_mobile',
  'install_desktop',
  'insights',
  'insert_photo',
  'insert_page_break',
  'insert_link',
  'insert_invitation',
  'insert_emoticon',
  'insert_drive_file',
  'insert_comment',
  'insert_chart_outlined',
  'insert_chart',
  'input',
  'info_outline',
  'info',
  'indeterminate_check_box',
  'incomplete_circle',
  'inbox',
  'important_devices',
  'import_export',
  'import_contacts',
  'imagesearch_roller',
  'image_search',
  'image_not_supported',
  'image_aspect_ratio',
  'image',
  'icecream',
  'ice_skating',
  'join_right',
  'join_left',
  'join_inner',
  'join_full',
  'javascript',
  'kitesurfing',
  'kitchen',
  'king_bed',
  'keyboard_voice',
  'keyboard_tab',
  'keyboard_return',
  'keyboard_option_key',
  'keyboard_option',
  'keyboard_hide',
  'keyboard_double_arrow_up',
  'keyboard_double_arrow_right',
  'keyboard_double_arrow_left',
  'keyboard_double_arrow_down',
  'keyboard_control_key',
  'keyboard_control',
  'keyboard_command_key',
  'keyboard_command',
  'keyboard_capslock',
  'keyboard_backspace',
  'keyboard_arrow_up',
  'keyboard_arrow_right',
  'keyboard_arrow_left',
  'keyboard_arrow_down',
  'keyboard_alt',
  'keyboard',
  'key_off',
  'key',
  'kebab_dining',
  'kayaking',
  'lyrics',
  'lunch_dining',
  'luggage',
  'lte_plus_mobiledata',
  'lte_mobiledata',
  'loyalty',
  'low_priority',
  'loupe',
  'loop',
  'looks_two',
  'looks_one',
  'looks_6',
  'looks_5',
  'looks_4',
  'looks_3',
  'looks',
  'logout',
  'logo_dev',
  'login',
  'lock_reset',
  'lock_person',
  'lock_outline',
  'lock_open',
  'lock_clock',
  'lock',
  'location_searching',
  'location_pin',
  'location_on',
  'location_off',
  'location_history',
  'location_disabled',
  'location_city',
  'local_taxi',
  'local_shipping',
  'local_see',
  'local_restaurant',
  'local_printshop',
  'local_print_shop',
  'local_post_office',
  'local_police',
  'local_play',
  'local_pizza',
  'local_phone',
  'local_pharmacy',
  'local_parking',
  'local_offer',
  'local_movies',
  'local_mall',
  'local_library',
  'local_laundry_service',
  'local_hotel',
  'local_hospital',
  'local_grocery_store',
  'local_gas_station',
  'local_florist',
  'local_fire_department',
  'local_drink',
  'local_dining',
  'local_convenience_store',
  'local_car_wash',
  'local_cafe',
  'local_bar',
  'local_attraction',
  'local_atm',
  'local_airport',
  'local_activity',
  'living',
  'live_tv',
  'live_help',
  'list_alt',
  'list',
  'liquor',
  'linked_camera',
  'link_off',
  'link',
  'linear_scale',
  'line_weight',
  'line_style',
  'line_axis',
  'lightbulb_outline',
  'lightbulb_circle',
  'lightbulb',
  'light_mode',
  'light',
  'library_music',
  'library_books',
  'library_add_check',
  'library_add',
  'lens_blur',
  'lens',
  'legend_toggle',
  'leave_bags_at_home',
  'leak_remove',
  'leak_add',
  'leaderboard',
  'layers_clear',
  'layers',
  'launch',
  'last_page',
  'laptop_windows',
  'laptop_mac',
  'laptop_chromebook',
  'laptop',
  'language',
  'landslide',
  'landscape',
  'lan',
  'label_outline',
  'label_off',
  'label_important_outline',
  'label_important',
  'label',
  'my_location',
  'my_library_music',
  'my_library_books',
  'my_library_add',
  'music_video',
  'music_off',
  'music_note',
  'museum',
  'multitrack_audio',
  'multiple_stop',
  'multiline_chart',
  'mp',
  'moving',
  'movie_filter',
  'movie_creation',
  'movie',
  'move_up',
  'move_to_inbox',
  'move_down',
  'mouse',
  'motorcycle',
  'motion_photos_paused',
  'motion_photos_pause',
  'motion_photos_on',
  'motion_photos_off',
  'motion_photos_auto',
  'mosque',
  'more_vert',
  'more_time',
  'more_horiz',
  'more',
  'moped',
  'mood_bad',
  'mood',
  'monochrome_photos',
  'monitor_weight',
  'monitor_heart',
  'monitor',
  'money_off_csred',
  'money_off',
  'money',
  'monetization_on',
  'model_training',
  'mode_standby',
  'mode_of_travel',
  'mode_night',
  'mode_fan_off',
  'mode_edit_outline',
  'mode_edit',
  'mode_comment',
  'mode',
  'mobiledata_off',
  'mobile_screen_share',
  'mobile_off',
  'mobile_friendly',
  'mms',
  'missed_video_call',
  'miscellaneous_services',
  'minor_crash',
  'minimize',
  'military_tech',
  'microwave',
  'mic_off',
  'mic_none',
  'mic_external_on',
  'mic_external_off',
  'mic',
  'messenger_outline',
  'messenger',
  'message',
  'merge_type',
  'merge',
  'menu_open',
  'menu_book',
  'menu',
  'memory',
  'meeting_room',
  'medication_liquid',
  'medication',
  'medical_services',
  'medical_information',
  'mediation',
  'media_bluetooth_on',
  'media_bluetooth_off',
  'maximize',
  'masks',
  'markunread_mailbox',
  'markunread',
  'mark_unread_chat_alt',
  'mark_email_unread',
  'mark_email_read',
  'mark_chat_unread',
  'mark_chat_read',
  'mark_as_unread',
  'margin',
  'maps_ugc',
  'maps_home_work',
  'map',
  'manage_search',
  'manage_history',
  'manage_accounts',
  'man',
  'male',
  'mail_outline',
  'mail_lock',
  'mail',
  'numbers',
  'now_widgets',
  'now_wallpaper',
  'notifications_paused',
  'notifications_on',
  'notifications_off',
  'notifications_none',
  'notifications_active',
  'notifications',
  'notification_important',
  'notification_add',
  'notes',
  'note_alt',
  'note_add',
  'note',
  'not_started',
  'not_listed_location',
  'not_interested',
  'not_accessible',
  'north_west',
  'north_east',
  'north',
  'nordic_walking',
  'noise_control_off',
  'noise_aware',
  'no_transfer',
  'no_stroller',
  'no_sim',
  'no_photography',
  'no_meeting_room',
  'no_meals_ouline',
  'no_meals',
  'no_luggage',
  'no_food',
  'no_flash',
  'no_encryption_gmailerrorred',
  'no_encryption',
  'no_drinks',
  'no_crash',
  'no_cell',
  'no_backpack',
  'no_adult_content',
  'no_accounts',
  'nights_stay',
  'nightlight_round',
  'nightlight',
  'nightlife',
  'night_shelter',
  'nfc',
  'next_week',
  'next_plan',
  'newspaper',
  'new_releases',
  'new_label',
  'network_wifi_3_bar',
  'network_wifi_2_bar',
  'network_wifi_1_bar',
  'network_wifi',
  'network_ping',
  'network_locked',
  'network_check',
  'network_cell',
  'nest_cam_wired_stand',
  'nearby_off',
  'nearby_error',
  'near_me_disabled',
  'near_me',
  'navigation',
  'navigate_next',
  'navigate_before',
  'nature_people',
  'nature',
  'nat',
  'output',
  'outlined_flag',
  'outlet',
  'outgoing_mail',
  'outdoor_grill',
  'outbox',
  'outbound',
  'outbond',
  'other_houses',
  'open_with',
  'open_in_new_off',
  'open_in_new',
  'open_in_full',
  'open_in_browser',
  'opacity',
  'online_prediction',
  'ondemand_video',
  'on_device_training',
  'oil_barrel',
  'offline_share',
  'offline_pin',
  'offline_bolt',
  'push_pin',
  'punch_clock',
  'published_with_changes',
  'publish',
  'public_off',
  'public',
  'psychology_alt',
  'psychology',
  'propane_tank',
  'propane',
  'production_quantity_limits',
  'private_connectivity',
  'privacy_tip',
  'priority_high',
  'print_disabled',
  'print',
  'price_check',
  'price_change',
  'preview',
  'present_to_all',
  'pregnant_woman',
  'precision_manufacturing',
  'power_settings_new',
  'power_off',
  'power_input',
  'power',
  'post_add',
  'portrait',
  'portable_wifi_off',
  'pool',
  'polymer',
  'polyline',
  'poll',
  'policy',
  'point_of_sale',
  'podcasts',
  'plus_one',
  'plumbing',
  'playlist_remove',
  'playlist_play',
  'playlist_add_circle',
  'playlist_add_check_circle',
  'playlist_add_check',
  'playlist_add',
  'play_lesson',
  'play_for_work',
  'play_disabled',
  'play_circle_outline',
  'play_circle_filled',
  'play_circle_fill',
  'play_circle',
  'play_arrow',
  'plagiarism',
  'place',
  'pix',
  'pivot_table_chart',
  'pinch',
  'pin_invoke',
  'pin_end',
  'pin_drop',
  'pin',
  'pie_chart_outlined',
  'pie_chart_outline',
  'pie_chart',
  'picture_in_picture_alt',
  'picture_in_picture',
  'picture_as_pdf',
  'piano_off',
  'piano',
  'php',
  'photo_size_select_small',
  'photo_size_select_large',
  'photo_size_select_actual',
  'photo_library',
  'photo_filter',
  'photo_camera_front',
  'photo_camera_back',
  'photo_camera',
  'photo_album',
  'photo',
  'phonelink_setup',
  'phonelink_ring',
  'phonelink_off',
  'phonelink_lock',
  'phonelink_erase',
  'phonelink',
  'phone_paused',
  'phone_missed',
  'phone_locked',
  'phone_iphone',
  'phone_in_talk',
  'phone_forwarded',
  'phone_enabled',
  'phone_disabled',
  'phone_callback',
  'phone_bluetooth_speaker',
  'phone_android',
  'phone',
  'phishing',
  'pets',
  'pest_control_rodent',
  'pest_control',
  'personal_video',
  'personal_injury',
  'person_search',
  'person_remove_alt_1',
  'person_remove',
  'person_pin_circle',
  'person_pin',
  'person_outline',
  'person_off',
  'person_add_disabled',
  'person_add_alt_1',
  'person_add_alt',
  'person_add',
  'person',
  'perm_scan_wifi',
  'perm_phone_msg',
  'perm_media',
  'perm_identity',
  'perm_device_information',
  'perm_device_info',
  'perm_data_setting',
  'perm_contact_calendar',
  'perm_contact_cal',
  'perm_camera_mic',
  'percent',
  'people_outline',
  'people_alt',
  'people',
  'pentagon',
  'pending_actions',
  'pending',
  'pedal_bike',
  'paypal',
  'payments',
  'payment',
  'pause_presentation',
  'pause_circle_outline',
  'pause_circle_filled',
  'pause_circle',
  'pause',
  'pattern',
  'password',
  'party_mode',
  'park',
  'paragliding',
  'panorama_wide_angle_select',
  'panorama_wide_angle',
  'panorama_vertical_select',
  'panorama_vertical',
  'panorama_photosphere_select',
  'panorama_photosphere',
  'panorama_horizontal_select',
  'panorama_horizontal',
  'panorama_fisheye',
  'panorama_fish_eye',
  'panorama',
  'pan_tool_alt',
  'pan_tool',
  'palette',
  'paid',
  'pageview',
  'pages',
  'padding',
  'quora',
  'quiz',
  'quickreply',
  'quick_contacts_mail',
  'quick_contacts_dialer',
  'queue_play_next',
  'queue_music',
  'queue',
  'question_mark',
  'question_answer',
  'query_stats',
  'query_builder',
  'qr_code_scanner',
  'qr_code_2',
  'qr_code',
  'rv_hookup',
  'running_with_errors',
  'run_circle',
  'rule_folder',
  'rule',
  'rtt',
  'rsvp',
  'rss_feed',
  'rowing',
  'router',
  'route',
  'rounded_corner',
  'roundabout_right',
  'roundabout_left',
  'rotate_right',
  'rotate_left',
  'rotate_90_degrees_cw',
  'rotate_90_degrees_ccw',
  'room_service',
  'room_preferences',
  'room',
  'roofing',
  'roller_skating',
  'roller_shades_closed',
  'roller_shades',
  'rocket_launch',
  'rocket',
  'ring_volume',
  'rice_bowl',
  'reviews',
  'restore_page',
  'restore_from_trash',
  'restore',
  'restaurant_menu',
  'restaurant',
  'restart_alt',
  'reset_tv',
  'request_quote',
  'request_page',
  'report_problem',
  'report_off',
  'report_gmailerrorred',
  'report',
  'reply_all',
  'reply',
  'replay_circle_filled',
  'replay_5',
  'replay_30',
  'replay_10',
  'replay',
  'repeat_one_on',
  'repeat_one',
  'repeat_on',
  'repeat',
  'repartition',
  'reorder',
  'remove_shopping_cart',
  'remove_road',
  'remove_red_eye',
  'remove_moderator',
  'remove_from_queue',
  'remove_done',
  'remove_circle_outline',
  'remove_circle',
  'remove',
  'remember_me',
  'refresh',
  'reduce_capacity',
  'redo',
  'redeem',
  'reddit',
  'recycling',
  'rectangle',
  'record_voice_over',
  'recommend',
  'recent_actors',
  'receipt_long',
  'receipt',
  'real_estate_agent',
  'read_more',
  'raw_on',
  'raw_off',
  'rate_review',
  'ramp_right',
  'ramp_left',
  'ramen_dining',
  'railway_alert',
  'radio_button_unchecked',
  'radio_button_on',
  'radio_button_off',
  'radio_button_checked',
  'radio',
  'radar',
  'r_mobiledata',
  'system_update_tv',
  'system_update_alt',
  'system_update',
  'system_security_update_warning',
  'system_security_update_good',
  'system_security_update',
  'sync_problem',
  'sync_lock',
  'sync_disabled',
  'sync_alt',
  'sync',
  'synagogue',
  'switch_video',
  'switch_right',
  'switch_left',
  'switch_camera',
  'switch_account',
  'switch_access_shortcut_add',
  'switch_access_shortcut',
  'swipe_vertical',
  'swipe_up_alt',
  'swipe_up',
  'swipe_right_alt',
  'swipe_right',
  'swipe_left_alt',
  'swipe_left',
  'swipe_down_alt',
  'swipe_down',
  'swipe',
  'swap_vertical_circle',
  'swap_vert_circle',
  'swap_vert',
  'swap_horizontal_circle',
  'swap_horiz',
  'swap_calls',
  'surround_sound',
  'surfing',
  'support_agent',
  'support',
  'supervisor_account',
  'supervised_user_circle',
  'superscript',
  'sunny_snowing',
  'sunny',
  'summarize',
  'subway',
  'subtitles_off',
  'subtitles',
  'subscriptions',
  'subscript',
  'subject',
  'subdirectory_arrow_right',
  'subdirectory_arrow_left',
  'style',
  'stroller',
  'strikethrough_s',
  'streetview',
  'stream',
  'straighten',
  'straight',
  'storm',
  'storefront',
  'store_mall_directory',
  'store',
  'storage',
  'stop_screen_share',
  'stop_circle',
  'stop',
  'sticky_note_2',
  'stay_primary_portrait',
  'stay_primary_landscape',
  'stay_current_portrait',
  'stay_current_landscape',
  'start',
  'stars',
  'star_rate',
  'star_purple500',
  'star_outline',
  'star_half',
  'star_border_purple500',
  'star_border',
  'star',
  'stairs',
  'stadium',
  'stacked_line_chart',
  'stacked_bar_chart',
  'ssid_chart',
  'square_foot',
  'square',
  'sports_volleyball',
  'sports_tennis',
  'sports_soccer',
  'sports_score',
  'sports_rugby',
  'sports_motorsports',
  'sports_mma',
  'sports_martial_arts',
  'sports_kabaddi',
  'sports_hockey',
  'sports_handball',
  'sports_gymnastics',
  'sports_golf',
  'sports_football',
  'sports_esports',
  'sports_cricket',
  'sports_basketball',
  'sports_baseball',
  'sports_bar',
  'sports',
  'spoke',
  'splitscreen',
  'spellcheck',
  'speed',
  'speaker_phone',
  'speaker_notes_off',
  'speaker_notes',
  'speaker_group',
  'speaker',
  'spatial_tracking',
  'spatial_audio_off',
  'spatial_audio',
  'space_dashboard',
  'space_bar',
  'spa',
  'south_west',
  'south_east',
  'south_america',
  'south',
  'source',
  'soup_kitchen',
  'sos',
  'sort_by_alpha',
  'sort',
  'solar_power',
  'social_distance',
  'soap',
  'snowshoeing',
  'snowmobile',
  'snowing',
  'snowboarding',
  'snooze',
  'snippet_folder',
  'snapchat',
  'sms_failed',
  'sms',
  'smoking_rooms',
  'smoke_free',
  'smartphone',
  'smart_toy',
  'smart_screen',
  'smart_display',
  'smart_button',
  'slow_motion_video',
  'slideshow',
  'sledding',
  'skip_previous',
  'skip_next',
  'skateboarding',
  'sip',
  'single_bed',
  'sim_card_download',
  'sim_card_alert',
  'sim_card',
  'signpost',
  'signal_wifi_statusbar_null',
  'signal_wifi_statusbar_connected_no_internet_4',
  'signal_wifi_statusbar_4_bar',
  'signal_wifi_off',
  'signal_wifi_connected_no_internet_4',
  'signal_wifi_bad',
  'signal_wifi_4_bar_lock',
  'signal_wifi_4_bar',
  'signal_wifi_0_bar',
  'signal_cellular_off',
  'signal_cellular_null',
  'signal_cellular_nodata',
  'signal_cellular_no_sim',
  'signal_cellular_connected_no_internet_4_bar',
  'signal_cellular_connected_no_internet_0_bar',
  'signal_cellular_alt_2_bar',
  'signal_cellular_alt_1_bar',
  'signal_cellular_alt',
  'signal_cellular_4_bar',
  'signal_cellular_0_bar',
  'sign_language',
  'sick',
  'shutter_speed',
  'shuffle_on',
  'shuffle',
  'shower',
  'show_chart',
  'shortcut',
  'short_text',
  'shopping_cart_checkout',
  'shopping_cart',
  'shopping_basket',
  'shopping_bag',
  'shopify',
  'shop_two',
  'shop_2',
  'shop',
  'shield_moon',
  'shield',
  'share_location',
  'share_arrival_time',
  'share',
  'severe_cold',
  'settings_voice',
  'settings_system_daydream',
  'settings_suggest',
  'settings_remote',
  'settings_power',
  'settings_phone',
  'settings_overscan',
  'settings_input_svideo',
  'settings_input_hdmi',
  'settings_input_composite',
  'settings_input_component',
  'settings_input_antenna',
  'settings_ethernet',
  'settings_display',
  'settings_cell',
  'settings_brightness',
  'settings_bluetooth',
  'settings_backup_restore',
  'settings_applications',
  'settings_accessibility',
  'settings',
  'set_meal',
  'sentiment_very_satisfied',
  'sentiment_very_dissatisfied',
  'sentiment_satisfied_alt',
  'sentiment_satisfied',
  'sentiment_neutral',
  'sentiment_dissatisfied',
  'sensors_off',
  'sensors',
  'sensor_window',
  'sensor_occupied',
  'sensor_door',
  'send_to_mobile',
  'send_time_extension',
  'send_and_archive',
  'send',
  'sell',
  'self_improvement',
  'select_all',
  'segment',
  'security_update_warning',
  'security_update_good',
  'security_update',
  'security',
  'search_off',
  'search',
  'sd_storage',
  'sd_card_alert',
  'sd_card',
  'sd',
  'scuba_diving',
  'screenshot_monitor',
  'screenshot',
  'screen_share',
  'screen_search_desktop',
  'screen_rotation_alt',
  'screen_rotation',
  'screen_lock_rotation',
  'screen_lock_portrait',
  'screen_lock_landscape',
  'scoreboard',
  'score',
  'science',
  'school',
  'schema',
  'schedule_send',
  'schedule',
  'scatter_plot',
  'scanner',
  'scale',
  'savings',
  'saved_search',
  'save_as',
  'save_alt',
  'save',
  'satellite_alt',
  'satellite',
  'sanitizer',
  'sailing',
  'safety_divider',
  'safety_check',
  'type_specimen',
  'two_wheeler',
  'tv_off',
  'tv',
  'turned_in_not',
  'turned_in',
  'turn_slight_right',
  'turn_slight_left',
  'turn_sharp_right',
  'turn_sharp_left',
  'turn_right',
  'turn_left',
  'tungsten',
  'tune',
  'tty',
  'tsunami',
  'try',
  'troubleshoot',
  'trip_origin',
  'trending_up',
  'trending_neutral',
  'trending_flat',
  'trending_down',
  'travel_explore',
  'translate',
  'transit_enterexit',
  'transgender',
  'transform',
  'transfer_within_a_station',
  'transcribe',
  'tram',
  'train',
  'traffic',
  'track_changes',
  'toys',
  'tour',
  'touch_app',
  'tornado',
  'topic',
  'tonality',
  'toll',
  'token',
  'toggle_on',
  'toggle_off',
  'today',
  'toc',
  'title',
  'tire_repair',
  'tips_and_updates',
  'timer_off',
  'timer_3_select',
  'timer_3',
  'timer_10_select',
  'timer_10',
  'timer',
  'timeline',
  'timelapse',
  'time_to_leave',
  'tiktok',
  'thunderstorm',
  'thumbs_up_down',
  'thumb_up_off_alt',
  'thumb_up_alt',
  'thumb_up',
  'thumb_down_off_alt',
  'thumb_down_alt',
  'thumb_down',
  'thermostat_auto',
  'thermostat',
  'theaters',
  'theater_comedy',
  'texture',
  'textsms',
  'text_snippet',
  'text_rotation_none',
  'text_rotation_down',
  'text_rotation_angleup',
  'text_rotation_angledown',
  'text_rotate_vertical',
  'text_rotate_up',
  'text_increase',
  'text_format',
  'text_fields',
  'text_decrease',
  'terrain',
  'terminal',
  'temple_hindu',
  'temple_buddhist',
  'telegram',
  'taxi_alert',
  'task_alt',
  'task',
  'tapas',
  'tap_and_play',
  'takeout_dining',
  'tag_faces',
  'tag',
  'tablet_mac',
  'tablet_android',
  'tablet',
  'table_view',
  'table_rows',
  'table_restaurant',
  'table_chart',
  'table_bar',
  'tab_unselected',
  'tab',
  'usb_off',
  'usb',
  'upload_file',
  'upload',
  'upgrade',
  'update_disabled',
  'update',
  'upcoming',
  'unsubscribe',
  'unpublished',
  'unfold_more',
  'unfold_less',
  'undo',
  'unarchive',
  'umbrella',
  'u_turn_right',
  'u_turn_left',
  'vrpano',
  'vpn_lock',
  'vpn_key_off',
  'vpn_key',
  'volunteer_activism',
  'volume_up',
  'volume_off',
  'volume_mute',
  'volume_down_alt',
  'volume_down',
  'volcano',
  'voicemail',
  'voice_over_off',
  'voice_chat',
  'visibility_off',
  'visibility',
  'villa',
  'vignette',
  'view_week',
  'view_timeline',
  'view_stream',
  'view_sidebar',
  'view_quilt',
  'view_module',
  'view_list',
  'view_kanban',
  'view_in_ar',
  'view_headline',
  'view_day',
  'view_cozy',
  'view_compact_alt',
  'view_compact',
  'view_comfy_alt',
  'view_comfy',
  'view_comfortable',
  'view_column',
  'view_carousel',
  'view_array',
  'view_agenda',
  'videogame_asset_off',
  'videogame_asset',
  'videocam_off',
  'videocam',
  'video_stable',
  'video_settings',
  'video_library',
  'video_label',
  'video_file',
  'video_collection',
  'video_camera_front',
  'video_camera_back',
  'video_call',
  'vibration',
  'vertical_split',
  'vertical_shades_closed',
  'vertical_shades',
  'vertical_distribute',
  'vertical_align_top',
  'vertical_align_center',
  'vertical_align_bottom',
  'verified_user',
  'verified',
  'vaping_rooms',
  'vape_free',
  'vaccines',
  'wysiwyg',
  'wrong_location',
  'wrap_text',
  'workspaces_outline',
  'workspaces_filled',
  'workspaces',
  'workspace_premium',
  'work_outline',
  'work_off',
  'work_history',
  'work',
  'wordpress',
  'woo_commerce',
  'woman',
  'wine_bar',
  'window',
  'wind_power',
  'wifi_tethering_off',
  'wifi_tethering_error_rounded',
  'wifi_tethering_error',
  'wifi_tethering',
  'wifi_protected_setup',
  'wifi_password',
  'wifi_off',
  'wifi_lock',
  'wifi_find',
  'wifi_channel',
  'wifi_calling_3',
  'wifi_calling',
  'wifi_2_bar',
  'wifi_1_bar',
  'wifi',
  'width_wide',
  'width_normal',
  'width_full',
  'widgets',
  'where_to_vote',
  'wheelchair_pickup',
  'whatshot',
  'whatsapp',
  'west',
  'weekend',
  'wechat',
  'webhook',
  'web_stories',
  'web_asset_off',
  'web_asset',
  'web',
  'wc',
  'wb_twilight',
  'wb_twighlight',
  'wb_sunny',
  'wb_shade',
  'wb_iridescent',
  'wb_incandescent',
  'wb_cloudy',
  'wb_auto',
  'waving_hand',
  'waves',
  'waterfall_chart',
  'water_drop',
  'water_damage',
  'water',
  'watch_off',
  'watch_later',
  'watch',
  'wash',
  'warning_amber',
  'warning',
  'warehouse',
  'wallpaper',
  'wallet_travel',
  'wallet_membership',
  'wallet_giftcard',
  'wallet',
  'youtube_searched_for',
  'yard',
  'zoom_out_map',
  'zoom_out',
  'zoom_in_map',
  'zoom_in',
];

export const dataPointsValues: { [k: string]: any } = {
  values: [
    {
      title: 'Account Number',
      name: 'accountNumber',
      valueV1: 'playerProfile.playerId',
      valueV2: 'playerProfile.playerId',
      cmsAvailability: ['Envoy', 'IGT', 'Local'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Tier Points Balance',
      name: 'tierPointBalance',
      valueV1: '',
      valueV2: 'playerBalances.a_Tier.amount',
      cmsAvailability: ['Envoy', 'IGT'],
      options: ['formatNumber'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Comps Balance',
      name: 'compsBalance',
      valueV1: '',
      valueV2: 'playerBalances.a_Comps.amount',
      cmsAvailability: ['OLKG'],
      options: ['formatNumber'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },

    {
      title: 'Card Number',
      name: 'cardNumber',
      valueV1: 'playerProfile.cardNumbers.cardId',
      valueV2: 'playerProfile.playerId',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Martial Status',
      name: 'martialStatus',
      valueV1: '',
      valueV2: 'playerProfile.playerProfile.martialStatus',
      cmsAvailability: ['Envoy', 'IGT'],
      availableAt: [],
    },
    {
      title: 'Gender',
      name: 'gender',
      valueV1: '',
      valueV2: 'playerProfile.gender',
      cmsAvailability: ['Local'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Military Status',
      name: 'militaryStatus',
      valueV1: 'playerProfile.militaryStatus',
      valueV2: '',
      cmsAvailability: ['Local'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Profile Title',
      name: 'profileTitle',
      valueV1: 'playerProfile.name.title',
      valueV2: 'playerProfile.playerProfile.title',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'First Name',
      name: 'firstName',
      valueV2: 'playerProfile.playerProfile.firstName',
      valueV1: 'playerProfile.name.first',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Last Name',
      name: 'lastName',
      valueV2: 'playerProfile.playerProfile.lastName',
      valueV1: 'playerProfile.name.last',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Middle Name',
      name: 'middleName',
      valueV1: 'playerProfile.name.middle',
      valueV2: 'playerProfile.playerProfile.middleName',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Full Name',
      name: 'fullName',
      valueV1: 'playerProfile.name.first + " " + this.playerProfile.name.last',
      valueV2: 'playerProfile.playerProfile.fullName',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Preferred Name',
      name: 'prefferedName',
      valueV1: 'playerProfile.name.preferred',
      valueV2: 'playerProfile.playerProfile.preferredName',
      value: '',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Generation',
      name: 'generation',
      valueV1: 'playerProfile.name.generation',
      valueV2: 'playerProfile.playerProfile.generation',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Email',
      name: 'email',
      valueV1: 'playerProfile.emails[0].address',
      valueV2: 'playerProfile.a_HomeEmail.address',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Mobile Phone',
      name: 'phone',
      valueV1: 'playerProfile.phoneNumbers[0].number',
      valueV2: 'playerProfile.a_HomePhone.phoneNumber',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Date of Enrollment',
      name: 'enrollmentDate',
      valueV1: 'playerProfile.gamingInfo.registeredDate',
      valueV2: 'playerProfile.playerProfile.dateOfEnrollment',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Point Balance',
      name: 'pointBalance',
      valueV1: 'playerProfile.gamingInfo.PlayerAccountBalance',
      valueV2: 'playerBalances.a_Points.amount',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      options: ['formatNumber'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Loyalty Points Balance',
      name: 'loyaltyPointBalance',
      valueV1: 'playerProfile.gamingInfo.PlayerAccountBalance',
      valueV2: 'playerBalances.a_Points.amount',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      options: ['formatNumber'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Tier level name',
      name: 'tierLevelName',
      valueV1: 'playerProfile.gamingInfo.tierLevel.name',
      valueV2: 'playerProfile.club.currentClub.name',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Tier level ID',
      name: 'tierLevelId',
      valueV1: 'playerProfile.gamingInfo.tierLevel.id',
      valueV2: 'playerProfile.club.currentClub.suffix',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [],
    },
    {
      title: 'Players Points Earned Today',
      name: 'pointsEarnedToday',
      valueV1: 'playerProfile.gamingInfo.pointsEarnedToday',
      valueV2: 'playerActivity.a_PointsEarned',
      options: ['formatNumber'],
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Loyalty Points Earned Today',
      name: 'loyaltyPointsEarnedToday',
      valueV1: 'playerProfile.gamingInfo.pointsEarnedToday',
      valueV2: 'playerActivity.a_PointsEarned',
      options: ['formatNumber'],
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Tier Points Earned Today',
      name: 'tierPointsEarnedToday',
      valueV1: 'playerProfile.gamingInfo.pointsEarnedToday',
      valueV2: 'playerActivity.a_TierPointsEarned',
      options: ['formatNumber'],
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Birth Date',
      name: 'birthDate',
      valueV1: 'playerProfile.birthDate',
      valueV2: 'playerProfile.playerProfile.dateOfBirthday',
      cmsAvailability: ['Local'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Image',
      name: 'image',
      valueV1: 'image',
      valueV2: 'image',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: ['tierLevelCard'],
    },
    {
      title: 'Age',
      name: 'age',
      valueV1: 'playerProfile.birthDate',
      valueV2: 'playerProfile.playerProfile.dateOfBirthday',
      cmsAvailability: ['IGT', 'Local', 'Envoy'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Free play balance',
      name: 'freePlayBalance',
      valueV1: 'playerProfile.freePlayBalance',
      valueV2: 'playerBalances.a_FreePlay.amount',
      cmsAvailability: ['Local', 'Envoy', 'IGT'],
      options: ['formatNumber'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
    {
      title: 'Moreplay',
      name: 'moreplayBalance',
      valueV1: 'playerProfile.freePlayBalance',
      valueV2: 'playerBalances.a_FreePlay.amount',
      cmsAvailability: ['Local', 'Envoy', 'IGT'],
      options: ['formatNumber'],
      availableAt: [
        'welcomeMessage',
        'dataPoints',
        'additionalInfo',
        'tierLevelCard',
      ],
    },
  ],
};

export const redemptionInformationTemplate = `
<h3>Redeem your points for cash.
{{conversionRateFrom}} = $ {{conversionRateTo}} in
{{conversionType}}
</h3>
<h4>Instructions</h4>
<ol start="1">
<li> Enter the amount of Free Play you want to purchase with your points. </li>
<li> Click "Purchase" to redeem.</li>
<li>Purchased Free Play will be instantly added to your account.</li>
</ol>
`;

export const redemptionV2InformationTemplate = `
<h3>Redeem your Comp Dollars
${'${{conversionRateFrom}}'} Comp Dollars = ${'${{conversionRateTo}}'} Match Bet</h3>
<h4>Instructions</h4>
<ol start="1">
<li>Select what you would like to redeem your Comp Dollars for.</li>
<li>Enter the amount you want to purchase.</li>
<li>Click "Purchase" to redeem.</li>
<li>Bring printed voucher to the Players Club to redeem.</li>
</ol>
`;

export const reemtpionInformationCss = `

.redemption-html-tmpl h3 {
        margin: 0px;
        font-size: 53px;
        font-weight: 500;
        line-height: 60px;
        letter-spacing: 0.01em;
        text-align: left;
      }
      .redemption-html-tmpl    h4 {
        margin: 0px;
        font-size: 40px;
        font-weight: 500;
        line-height: 52px;
        letter-spacing: 0.01em;
        text-align: left;
      }
      .redemption-html-tmpl ol > li {
        font-size: 34px;
        font-weight: 400;
        line-height: 52px;
        letter-spacing: 0.03em;
        text-align: left;
      }

    @meida (max-width: 1200px) {
        .redemption-html-tmpl h3 {
            font-size: 26px;
            line-height: 30px;
        }
        .redemption-html-tmpl    h4 {
            font-size: 20px;
            line-height: 26px;
        }
        .redemption-html-tmpl ol > li {
            font-size: 17px;
            line-height: 26px;
        }
    }
`;

export const giftCardInformationTemplate = `
<h3>Instructions</h3>
<ol start="1">
<li>Enter the amount you want to purchase between $ {{conversionRateFrom}} - $ {{conversionType}}. </li>
<li>Click "Confirm".</li>
<li>Check your email for a message containing your unique gift card link.</li>
<li>From the link, select your desired eCode gift card.</li>
</ol>
`;

export const giftCardInformationCss = `

.redemption-html-tmpl h3 {
        margin: 0px;
        font-size: 53px;
        font-weight: 500;
        line-height: 60px;
        letter-spacing: 0.01em;
        text-align: left;
      }
      .redemption-html-tmpl    h4 {
        margin: 0px;
        font-size: 40px;
        font-weight: 500;
        line-height: 52px;
        letter-spacing: 0.01em;
        text-align: left;
      }
      .redemption-html-tmpl ol > li {
        font-size: 34px;
        font-weight: 400;
        line-height: 52px;
        letter-spacing: 0.03em;
        text-align: left;
      }
    
    @media (max-width: 1200px) {
        .redemption-html-tmpl h3 {
            font-size: 26px;
            line-height: 30px;
        }
        .redemption-html-tmpl    h4 {
            font-size: 20px;
            line-height: 26px;
        }
        .redemption-html-tmpl ol > li {
            font-size: 17px;
            line-height: 26px;
        }
    }
`;
